import { ProductArea, EMULATOR_AREAS } from '@localstack/constants';
import { UseAuthProviderReturnType } from '@localstack/types';

import { useEntitledEmulators } from './entitled-emulators';

type Props = {
  useAuthProvider: () => UseAuthProviderReturnType;
};

/**
 * Whether an area exists for this workspace, pooled across every emulator it is entitled to.
 *
 * Not a permission check: `can` and `hasFeature` decide what a page shows, upsell included,
 * this decides whether the page is worth offering.
 */
export const useProductArea = ({ useAuthProvider }: Props): ((area: ProductArea) => boolean) => {
  const entitledEmulators = useEntitledEmulators({ useAuthProvider });
  const supported = new Set(entitledEmulators.flatMap((emulator) => EMULATOR_AREAS[emulator]));

  return (area: ProductArea) => supported.has(area);
};
